export default {"src":"/_next/static/media/NAFlag.e155d3c6.svg","height":24,"width":19};